<div *ngIf="errorMessages.length > 0">
  <p-messages severity="error">
    <ng-template pTemplate>
      <ul>
        <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
      </ul>
    </ng-template>
  </p-messages>
</div>
<p-dialog
  [(visible)]="showRelatedDocumentsNotAlignedWithScopeConfirmationModal"
  [style]="{ width: '40vw' }"
  (onHide)="closeRelatedDocumentsNotAlignedWithScopeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ relatedDocumentsNotAlignedWithScopeConfirmationMessage }}</span>
  </div>
  <ul>
    <li
      *ngFor="let documentNumber of documentNumbersNotAlignedWithParentDocument"
    >
      {{ documentNumber }}
    </li>
  </ul>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeRelatedDocumentsNotAlignedWithScopeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="updateRelatedDocumentList()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>
<form [formGroup]="trainingMaterialForm" (keydown.enter)="$event.preventDefault()">
    <div class="fields-row">
        <div class="field">
            <bpt-text-input label="Instructions" 
            [multiLine]="true"
            id="instructions"
            formControlName="instructions"
            placeholder="Add important notes, practice examples, etc.">
            </bpt-text-input>
        </div>
    </div>
    <div class="fields-row">
        <div class="field">
            <bpt-text-input 
            label="URL Link"
            id="urlLink"
            formControlName="urlLink">
            </bpt-text-input>
        </div>
        <div class="field align-self-center">
            <p-checkbox
            p-label-active
            class="ml-3"
            label="URL is a video to embed"
            [binary]="true"
            formControlName="isURLVideo"
            >
            </p-checkbox>
        </div>
    </div>
    <p-fieldset legend="Attachments" [toggleable]="true">
        <div class="field">
            <bpt-file-upload
            *ngIf="showFileUpload === true"
            [uploadFiles]="uploadSucceeds"
            [deleteFile]="deleteFile"
            [fileNames]="savedFiles"
            [fileTypes]="fileTypes"
            [maxSize]="maxFileSize"
            [fileLimit]="courseAttachmentMaxLimit"
          ></bpt-file-upload>
        </div>
    </p-fieldset>
    
    <div class="relatedDocuments">
        <p-fieldset legend="Related Documents" [toggleable]="true">
          <div
            *ngFor="let document of linkedDocuments; trackBy: trackByDocumentNumber"
            class="mt-1"
          >
            <div class="grid">
              <div class="col-10">
                <span class="">
                  <a
                    class="ml-3 underline blue-color cursor-pointer overflow-ellipse"
                    (click)="loadDocumentDetails(document.number, document.version)"
                  >
                    {{ document.number }} {{ document.title }}
                  </a>
                </span>
              </div>
        
              <div class="col-2">
                <em
                  class="ml-2 fa fa-trash blue-color cursor-pointer"
                  (click)="openDeleteConfirmationModal(document.number)"
                ></em>
              </div>
            </div>
          </div>
        </p-fieldset>
        <p-fieldset legend="Search Related Documents" [toggleable]="true">
          <div class="col mb-2 relatedDocumentsSearchPanel">
            <app-document-library-search *ngIf="showDocumentSearch === true"
              (shouldAddLinkItemsButtonDisplayed)="showOrHideAddRelatedDocumentButton($event)"
              (emitSelectedData)="onSelectionOrDeselection($event)"
              [panelListScreen]="courseTrainingMaterial"
            ></app-document-library-search>
          </div>
          <div class="col mb-2">
            <p-button
            appPreventDoubleClick
              label="Add Related Document"
              icon="fa fa-plus"
              id="addRelatedDocumentsButton"
              styleClass="p-button-outlined"
              iconPos="left"
              pTooltip="Add Related Document"
              (debounceClick)="addRelatedDocuments()"
              [disabled]="selectedDocuments === null || selectedDocuments.length === 0"
            >
            </p-button>
          </div>
        </p-fieldset>
        </div>
        <div class="button">
            <p-button
            appPreventDoubleClick
              label="Save"
              type="submit"
              id="courseSaveButton"
              class="align-right"
              styleClass="bpt-button-compact"
              (debounceClick)="saveCourse()"
            >
            </p-button>

            <p-button
            appPreventDoubleClick
              label="Previous"
              type="submit"
              id="courseTrainingMaterialSaveButton"
              class="align-left"
              styleClass="bpt-button-compact"
              (debounceClick)="openPreviousTab()"
            >
            </p-button>
          </div>
</form>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]= "InactiveAssignmentGroupField"  (confirmed)="saveDocumentwithInactiveAssignmentGroup()" (dialogClosed)="closeConfirmationDailog($event)"></app-confirmation-dialog>
